<app-core 
  [appTitle]="title"
  [imageMenuCode]="imageMenuCode"
  [loginTheme]="theme"
></app-core>
